import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import {DeviceState} from 'user/types'

import getFingerprint from '../../services/fingerprint'

export const initialState: DeviceState = {
  id: null
}

const {actions, reducer} = createSlice({
  name: 'device',
  initialState,
  reducers: {
    /**
     *
     * Sets the device id from a payload
     * @param state - The device state, it should already be injected
     * @param payload - Payload containing an id
     * @example
     * ```typescript
     * setDeviceId(deviceId)
     * ```
     */
    setDeviceId: (state: DeviceState, action: PayloadAction<string>) => {
      state.id = action.payload
    }
  }
})

/**
 *
 * Dispatches @fingerprintjs/fingerprintjs that will eventually return the deviceId
 * To be saved on the device module
 * @example
 * ```typescript
 * dispatch(requestFingerprint())
 * ```
 */
export const requestFingerprint = () => async dispatch => {
  const deviceId = await getFingerprint()

  dispatch(setDeviceId(deviceId))
}

/**
 *
 * Returns the deviceId saved by requestFingerprint or manually by setDeviceId
 * inside device module
 * @param state - The device state
 * @example
 * ```typescript
 * const deviceId = getDeviceId(state)
 * ```
 */
export const getDeviceId = (state: {device: DeviceState}): string =>
  state.device.id

export const {setDeviceId} = actions
export default reducer
